import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

const Login = lazy(() => import('Pages/Auth/Login'));
const Logout = lazy(() => import('Pages/Auth/Logout'));
const Register = lazy(() => import('Pages/Auth/Register'));
const Confirm = lazy(() => import('Pages/Auth/Confirm'));
const ForgetPassword = lazy(() => import('Pages/Auth/ForgetPassword')); // comentado - página em reconstrução
const LockScreen = lazy(() => import('Pages/Auth/LockScreen'));
const SetPassword = React.lazy(() => import('Pages/Auth/Setpassword/Page'));


const AuthRoutes: RouteObject[] = [
    {
      path: 'register',
      element: <LoadComponent component={Register} />,
    },
    {
      path: 'login',
      element: <LoadComponent component={Login} />,
    },
    {
      path: 'forget-password',
      element: <LoadComponent component={ForgetPassword} />,
    }, // comentado - página em reconstrução
    {
      path: 'set-password',
      element: <LoadComponent component={SetPassword} />,
    },
    //? Without Tenant
    {
      path: 'logout',
      element: <LoadComponent component={Logout} />,
    },
    {
      path: 'confirm',
      element: <LoadComponent component={Confirm} />,
    },
    {
      path: 'lock-screen',
      element: <LoadComponent component={LockScreen} />,
    },
    //? With Tenant / Relation
    {
      path: 'login/:cnpj',
      element: <LoadComponent component={Login} />,
    },
    {
      path: 'login/:cnpj/:relation',
      element: <LoadComponent component={Login} />,
    },
    {
      path: 'confirm/:cnpj',
      element: <LoadComponent component={Confirm} />,
    },
    {
      path: 'lock-screen/:cnpj',
      element: <LoadComponent component={LockScreen} />,
    },
    {
      path: 'logout/:cnpj',
      element: <LoadComponent component={Logout} />,
    },

]

export default AuthRoutes;
